import React, { Component } from 'react';
import { Row, Col } from "react-bootstrap";

class MensajeRetraso extends Component {
    state = {  }
    render() { 
        return (
            <div className="custom-alert-danger" style={{padding: 5,}}>
                <Row>
                    <Col md ={12} align = "justify" style={{fontSize: 13}}>
                        Actualmente presentas un retraso en el pago y no puedes acceder a esta función.
                        <div>Te recomendamos pagar a tiempo para evitar el pago de intereses.</div>
                        <div>Para tu comodidad puedes realizar la transferencia bancaria y registrarla en la opción <strong>ESTADO DE CUENTA</strong></div>
                    </Col>
                </Row>
            </div>
        );
    }
}
 
export default MensajeRetraso;


// WEBPACK FOOTER //
// ./src/shared/MensajeRetraso.jsx